import { useEffect } from 'react'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import { useIraConstraints } from './useIraConstraints'

export const useCashJournalConstraints = (sourceAccount: string, destinationAccount: string) => {
  const getBaseUrl = () => `${getAppConfigSetting('apiUrl')}${SENTINEL_API}`
  const url = `${getBaseUrl()}/ira_constraints/${sourceAccount}/${destinationAccount}`

  const { handleChange, constraintData, constraintError, constraintLoading } = useIraConstraints(url)

  useEffect(() => {
    if (sourceAccount && destinationAccount) {
      handleChange()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceAccount, destinationAccount])

  return { constraintData, constraintError, constraintLoading }
}
